// Used to limit how far into the future the public can see available slots
// End date is non-inclusive ( -1)
export const CUTOFF_DAYS_DEFAULT = 12 * 7 - 1 // 12 weeks
export const CUTOFF_DAYS_COVID_VACCINATION = 12 * 7 - 1 // 12 weeks

// Admin booking
export const VISIBLE_BOOKING_DAYS_ADMIN = 24 * 7 - 1 // 24 weeks
